import { IDenovoIconComponentProps } from "../interfaces";

export const MoleculeLoader: React.FC<IDenovoIconComponentProps> = ({
  width = 24,
  height = 24,
  color = "currentColor",
  className,
}: IDenovoIconComponentProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth={1.5}
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}>
    <line x1="12" y1="7" x2="7" y2="14" />
    <line x1="12" y1="7" x2="17" y2="14" />
    <line x1="7" y1="14" x2="17" y2="14" />
    <line x1="12" y1="7" x2="12" y2="2" />
    <line x1="7" y1="14" x2="3" y2="17" />
    <line x1="17" y1="14" x2="21" y2="17" />
    <circle cx="12" cy="7" r="2" fill={color} />
    <circle cx="7" cy="14" r="2" fill={color} />
    <circle cx="17" cy="14" r="2" fill={color} />
    <circle cx="12" cy="2" r="1.5" fill={color} opacity={0.5} />
    <circle cx="3" cy="17" r="1.5" fill={color} opacity={0.5} />
    <circle cx="21" cy="17" r="1.5" fill={color} opacity={0.5} />
  </svg>
);
